// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-swap-enter-active[data-v-4128a74f]{animation:page-enter-data-v-4128a74f 1s}@keyframes page-enter-data-v-4128a74f{0%{opacity:0;transform:translate3d(0,80px,0)}to{opacity:1;transform:translateZ(0)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
